import { FleetEventUIDto, IFleetEventUIDto } from "@/lib/dto/event/event-ui.dto";
import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";

export const FleetEventDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IFleetEventUIDto> {
  getIdentifier(entity: IFleetEventUIDto): string {
    return entity.id || `${entity.recurringEventId}-${entity.start}`;
  }

  protected mapEntity(entity: IFleetEventUIDto): IFleetEventUIDto {
    return new FleetEventUIDto(entity);
  }
})();
